module.exports = __webpack_public_path__ + "img/receiveCouponImg.66fbc254.png";